
import qs from 'query-string'
import { computed, defineComponent, onMounted, ref, getCurrentInstance } from 'vue'
import api from '@/api/api'
import SpinnerLoader from '@/components/SpinnerLoader.vue'
import useRouter from '@/hooks/useRouter'
import { useModalStore } from '@/store/stores/modal'
import { ImportantError } from '@/helpers/Error'
import ClientForm from '@/components/clientForm/ClientForm.vue'
export default defineComponent({
    components: { SpinnerLoader, ClientForm },
    setup(props, {}) {
        const root = getCurrentInstance()!.proxy
        const loading = ref(true)
        const { route, router } = useRouter(root)
        const enableSms = ref(false)
        const showClientForm = ref(true)
        const modalStore = useModalStore()
        const showConnectModal = computed(() => !loading.value && !showClientForm.value)
        const showClientFormModal = computed(() => !loading.value && showClientForm.value)
        onMounted(async () => {
            loading.value = true
            showClientForm.value = await api.clientForm.getClientFormExists().then(res => !res.data?.value)
            if (!showClientForm.value) {
                await createProject()
            }
            loading.value = false
        })
        const onAnswersSaved = async () => {
            showClientForm.value = false
            await createProject()
        }
        const clientFormExtra = computed(() => {
            return { encodedUserData: route.value.query?.userData }
        })
        const createProject = async () => {
            loading.value = true
            const query = route.value.query
            const params = route.value.params

            try {
                const res = await api.project.initFromMarketPlace({
                    type: params.connectorType,
                    encodedUserData: query.userData,
                    userSign: query.userDataSign,
                    companyId: query.companyId,
                    token: query.token,
                    enableSms: enableSms.value,
                } as any)
                if (res.error) {
                    new ImportantError('Dikidi init from marketplace error', { payload: res })
                    modalStore.open({ text: 'Ошибка подключения, обратитесь в техподдержку' })
                    loading.value = false
                    return
                }
                const projectId = res.data['project']['id']
                root.$store.commit('project/updateCurrentAddingConnector', 'whatsapp')
                await root.$store.dispatch('project/setProjects')
                router.replace(`/project/${projectId}/onBoarding`)
            } catch (error) {
                new ImportantError('Error during request to marketplace', { originalError: error })
                modalStore.open({ text: 'Ошибка подключения, обратитесь в техподдержку' })
                loading.value = false
            }
        }
        return {
            loading,
            enableSms,
            createProject,
            showClientForm,
            onAnswersSaved,
            showConnectModal,
            showClientFormModal,
            clientFormExtra,
        }
    },
})
